import { render, staticRenderFns } from "./GlLogoBizoope.vue?vue&type=template&id=49bb30dc&"
import script from "./GlLogoBizoope.vue?vue&type=script&lang=js&"
export * from "./GlLogoBizoope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports